import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useCheckoutUrlQuery from 'queries/useCheckoutUrlQuery';
import Events from '@activebrands/core-web/libs/Events';
import { getBasketPaymentMethod } from '@activebrands/core-web/state/basket/actions';
import { addLocalePrefix } from '@activebrands/core-web/utils/add-locale-prefix';
import { useLocation } from '@reach/router';

// @todo: THIS IS NOT TESTED!
/*
    To decide where the widget will be placed,
    just render a <div id="klarna-checkout-container" /> somewhere and it will be placed there.
*/
const KlarnaPaymentContainer = () => {
    const { checkoutResponsePage } = useCheckoutUrlQuery();

    const { locale } = useSelector(state => state.application);
    const { address, paymentMethodId, payment } = useSelector(state => state.basket);
    const dispatch = useDispatch();
    const location = useLocation();

    const successUrl = `${location.origin}${addLocalePrefix(checkoutResponsePage)}`;

    useEffect(() => {
        if (payment) {
            // Secure that klarna container do exist
            const klarnaContainer = document.getElementById('klarna-checkout-container');

            if (payment.formHtml && klarnaContainer) {
                const script = document.createElement('div');
                script.innerHTML = payment.formHtml.trim();
                const klarnaScript = script.getElementsByTagName('script')[0].innerHTML;

                const tag = document.createElement('script');
                tag.type = 'text/javascript';
                tag.async = true;
                tag.innerHTML = klarnaScript;
                tag.id = 'klarna-checkout-script';
                tag.style.paddingBottom = '30px';
                klarnaContainer.appendChild(tag);

                Events.trigger('payment.loaded');
            } else {
                // When this happens response has a completely different set of data
                // As warning (Response Changed) and basket is a part of it
                if (payment.warning && payment.warning.code === 3) {
                    // @todo add error handeling
                    // onError &&
                    //     onError(
                    //         'Out of stock',
                    //         'Unfortunately we had to remove a product from your shopping cart due to low stock levels.'
                    //     );
                }
            }
        }
    }, [payment]);

    useEffect(() => {
        if (paymentMethodId) {
            dispatch(getBasketPaymentMethod({ paymentMethodId, successUrl, locale, address }));
        }
    }, []);

    return null;
};

export default KlarnaPaymentContainer;
